import { memo } from "react"
import { CameraName, IconPlay, IconSize, GridCameraName } from "./sxVisualizacaoEvento"
import { DownloadForOffline, HeadsetMic, PlayCircleFilled } from "@mui/icons-material"
import { Box, Tooltip } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"

const LineLigacaoPlay = ({ title, ligacao, handleOpenAudio }) => {
    const { id, dt_inicio } = ligacao
    const data = dt_inicio.split("T")[0].split("-").join("/")
    const link = `http://${global.ip_pbx}:3002/BuscaGravacao/?=/${data}/${id}`
    return (
        <Grid xs={12} container >
            <Grid xs={9} sx={GridCameraName}>
                <Box component='div'><HeadsetMic sx={IconSize}/></Box>
                <Box component='div' sx={{ ...CameraName, maxWidth: '100%' }}>{title}</Box>
            </Grid>
            <Grid xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', maxHeight: '20px' }}>
                <Tooltip title={'Em Breve'} placement="left" arrow>
                    <Box component='div' sx={IconPlay}><DownloadForOffline sx={IconSize}/></Box>
                </Tooltip>
                <Tooltip title={'Em Breve'} placement="left" arrow>
                    <Box component='div'sx={IconPlay}><PlayCircleFilled sx={IconSize} onClick={() => handleOpenAudio(link)}/> </Box>
                </Tooltip>
            </Grid>
        </Grid>
    )
}

export default memo(LineLigacaoPlay)
